const highQualityLocationsWhitelist = {
  regions: new Set([
    'Los Angeles',
    'Orange County',
    'San Diego',
    'Malibu',
    'Bay Area',
    'South Florida',
    'Palm Beach',
    'Miami',
    'Orlando',
    'Houston',
    'Dallas',
    'New England'
  ]),
  states: new Set([
    'Alabama',
    'Alaska',
    'Arizona',
    'Florida',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming'
  ]),
  // please update countryCodesToNames as well when adding countries
  countries: new Set([
    'Australia',
    'Canada',
    'India',
    'South Africa',
    'United Kingdom'
  ]),
  // maps ISO 3166-1 alpha-2 country codes to country names.
  countryCodesToNames: {
    AU: 'Australia',
    CA: 'Canada',
    IN: 'India',
    ZA: 'South Africa',
    GB: 'United Kingdom'
  },
  continents: new Set(['Europe', 'Asia'])
}

export default highQualityLocationsWhitelist
